import styled from 'styled-components'

export const PageStyle = styled.div`
  background: radial-gradient(#4c8d99,#1d3242);
  color: #fff;

  .pageContainer {
    height: 100vh;
    display: grid;
    grid-template-rows: 80px 1fr 10px;
    max-width: 800px;
    margin: 0 auto;
  }

  header {
    h5 {
      margin: 0;
    }
    select.form-input {
      text-align-last: center;
      border: none;
      border-radius: 18px;
      padding: 4px 16px;
      font-size: 14px;
    }
  }

  .questionsContainer {
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.9);
    overflow-y: scroll;
  }
`
